import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import PageTitle from '../../../components/Text/PageTitle';
import UemOnboardingForm from './components/UemOnboardingForm';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import ArrowLeft from '../../../components/Icons/ArrowLeft';
import useUemOnboarding from './useUemOnboarding';

function UemOnboarding() {
  const [t] = useTranslation();
  const { id } = useParams();
  const { uemData } = useUemOnboarding(id);
  const theme = useTheme();
  const navigate = useNavigate();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    navigate('/uemOnboarding');
  };

  return (
    <>
      <Breadcrumbs
        activeLinks={[{ label: t('pages.uemOnboarding.title'), url: '/uemOnboarding' }]}
        disabledLinks={
          id
            ? [uemData ? `${uemData.type} ${uemData.companyName}` : 'Loading...']
            : [t('pages.uemOnboarding.newOnboarding')]
        }
      />

      <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '2.75rem' }}>
        <ArrowLeft
          stroke={theme.palette.primary.main}
          style={{ cursor: 'pointer', marginRight: '1rem' }}
          onClick={handleClose}
        />
        {id ? (
          <PageTitle>{t('pages.uemOnboarding.titleEdit')}</PageTitle>
        ) : (
          <PageTitle>{t('pages.uemOnboarding.newOnboarding')}</PageTitle>
        )}
      </Box>
      <UemOnboardingForm />
    </>
  );
}

export default UemOnboarding;
